"use client";

import { ArrowRight, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyForAFreshStart() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>();
  const {
    ref: paraRef,
    isVisible: paraVisible
  } = useRevealOnScroll<HTMLParagraphElement>();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: trustRef,
    isVisible: trustVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const trustBadges = ["Free estimate", "No hidden fees", "Satisfaction guaranteed"];
  return <section data-section-id="237" id="ready-for-a-fresh-start" className="bg-background text-foreground relative overflow-hidden py-32 px-4">
      {}
      <div className="absolute top-0 left-0 right-0 flex items-center justify-center">
        <div className="h-px bg-border flex-1" />
        <span className="px-4 font-serif text-muted-foreground text-sm">§</span>
        <div className="h-px bg-border flex-1" />
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 flex items-center justify-center">
        <div className="h-px bg-border flex-1" />
        <span className="px-4 font-serif text-muted-foreground text-sm">§</span>
        <div className="h-px bg-border flex-1" />
      </div>

      {}
      <div aria-hidden="true" className="pointer-events-none absolute -top-16 -left-8 sm:-top-20 sm:-left-12 select-none">
        <span className="font-serif text-[16rem] sm:text-[22rem] leading-none text-primary/10" style={{
        fontWeight: 400
      }}>
          *
        </span>
      </div>

      {}
      <div aria-hidden="true" className="pointer-events-none absolute bottom-0 right-0 w-64 h-64 sm:w-96 sm:h-96 opacity-20" style={{
      backgroundImage: "linear-gradient(to bottom, var(--border) 1px, transparent 1px)",
      backgroundSize: "100% 28px",
      maskImage: "linear-gradient(to top left, hsl(0 0% 0% / 1), transparent 70%)",
      WebkitMaskImage: "linear-gradient(to top left, hsl(0 0% 0% / 1), transparent 70%)"
    }} />

      <div className="relative mx-auto max-w-5xl text-center">
        {}
        <div ref={eyebrowRef} className={`transition-all duration-700 ease-out ${eyebrowVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="font-mono text-xs sm:text-sm uppercase tracking-[0.25em] text-primary">
            — Book now
          </span>
        </div>

        {}
        <h2 ref={headlineRef} className={`font-default font-semibold mt-8 text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[1.05] text-foreground transition-all duration-1000 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        letterSpacing: "-0.03em"
      }}>
          Stop scrubbing your weekends. Start{" "}
          <span className="relative inline-block italic font-serif">
            living beautifully
            <svg aria-hidden="true" className="absolute left-0 -bottom-2 sm:-bottom-3 w-full h-3 sm:h-4" viewBox="0 0 300 12" preserveAspectRatio="none" fill="none">
              <path d="M2 8 C 60 2, 120 11, 180 5 S 280 9, 298 4" stroke="var(--chart-1)" strokeWidth="3" strokeLinecap="round" />
            </svg>
          </span>
          .
        </h2>

        {}
        <p ref={paraRef} className={`mt-10 mx-auto max-w-[580px] text-base sm:text-lg text-muted-foreground leading-relaxed transition-all duration-700 delay-100 ease-out ${paraVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          Experience a pristine home with our professional cleaning services. Get an instant quote today and reclaim your time for what truly matters.
        </p>

        {}
        <div ref={ctaRef} className={`mt-12 flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-700 delay-200 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Button asChild size="lg" className="h-14 px-8 rounded-lg text-base bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg">
            <Link to="/OurCleaningMenuPage">
              Get an Instant Quote
              <ArrowRight className="ml-1 h-5 w-5" />
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="h-14 px-8 rounded-lg text-base border-border bg-transparent text-foreground hover:bg-accent hover:text-accent-foreground">
            <Link to="tel:5551234567">
              <Phone className="h-5 w-5" />
              Call (555) 123-4567
            </Link>
          </Button>
        </div>

        {}
        <div ref={trustRef} className={`mt-10 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs sm:text-sm text-muted-foreground transition-all duration-700 delay-300 ease-out ${trustVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {trustBadges.map((badge, i) => <div key={badge} data-index={i} className="flex items-center gap-3">
              <span className="font-mono uppercase tracking-wider">
                {badge}
              </span>
              {i < trustBadges.length - 1 && <span className="text-primary text-base leading-none">·</span>}
            </div>)}
        </div>
      </div>
    </section>;
}